/* ============================================================
   Product description "Read more / Read less"
   Safe to load globally
   ============================================================ */

(function () {
  function toggleReadmore(root) {
    // Prevent double-binding (important for section reloads)
    if (root.dataset.readmoreInit === '1') return;
    root.dataset.readmoreInit = '1';

    const btn = root.querySelector('[data-readmore-toggle]');
    const rest = root.querySelector('[data-readmore-rest]');
    const more = root.querySelector('[data-readmore-more]');
    const less = root.querySelector('[data-readmore-less]');

    // If there's nothing to expand, do nothing
    if (!btn || !rest || !more || !less) return;

    btn.addEventListener('click', function () {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      const nextOpen = !isOpen;

      btn.setAttribute('aria-expanded', String(nextOpen));

      // Toggle the rest content
      rest.classList.toggle('hidden', !nextOpen);

      // Toggle labels
      more.classList.toggle('hidden', nextOpen);
      less.classList.toggle('hidden', !nextOpen);
    });
  }

  function init() {
    const blocks = document.querySelectorAll('[data-readmore]');
    if (!blocks.length) return; // nothing to do

    blocks.forEach(toggleReadmore);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section reloads (theme editor, AJAX, quick view, etc.)
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Description accordion line-clamp "Read more / Read less"
   ============================================================ */

(function () {
  function initClampReadmore(root) {
    if (root.dataset.readmoreClampInit === '1') return;
    root.dataset.readmoreClampInit = '1';

    const content = root.querySelector('[data-readmore-clamp-content]');
    const btn = root.querySelector('[data-readmore-clamp-toggle]');
    const more = root.querySelector('[data-readmore-more]');
    const less = root.querySelector('[data-readmore-less]');

    if (!content || !btn || !more || !less) return;

    // Show button only if content is actually clamped
    function checkOverflow() {
      if (root.classList.contains('is-expanded')) return;
      if (content.scrollHeight > content.clientHeight + 1) {
        btn.classList.remove('hidden');
      } else {
        btn.classList.add('hidden');
      }
    }

    // Check after accordion opens (content may have 0 height while closed)
    const details = root.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) requestAnimationFrame(checkOverflow);
      });
      if (details.open) requestAnimationFrame(checkOverflow);
    } else {
      requestAnimationFrame(checkOverflow);
    }

    btn.addEventListener('click', function () {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      const nextOpen = !isOpen;

      btn.setAttribute('aria-expanded', String(nextOpen));
      root.classList.toggle('is-expanded', nextOpen);
      more.classList.toggle('hidden', nextOpen);
      less.classList.toggle('hidden', !nextOpen);
    });
  }

  function init() {
    document.querySelectorAll('[data-readmore-clamp]').forEach(initClampReadmore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
